import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actions", "count", "selectedIds", "form"]

  connect() {
    this.updateUI()
  }

  toggle(event) {
    this.updateUI()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(checkbox => {
      if (!checkbox.disabled) {
        checkbox.checked = checked
      }
    })
    this.updateUI()
  }

  updateUI() {
    const checkedBoxes = this.checkboxTargets.filter(cb => cb.checked && !cb.disabled)
    const enabledBoxes = this.checkboxTargets.filter(cb => !cb.disabled)
    const count = checkedBoxes.length

    // Update count display
    if (this.hasCountTarget) {
      this.countTarget.textContent = count
    }

    // Show/hide actions
    if (this.hasActionsTarget) {
      if (count > 0) {
        this.actionsTarget.classList.remove("hidden")
      } else {
        this.actionsTarget.classList.add("hidden")
      }
    }

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      if (enabledBoxes.length === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (count === 0) {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = false
      } else if (count === enabledBoxes.length) {
        this.selectAllTarget.checked = true
        this.selectAllTarget.indeterminate = false
      } else {
        this.selectAllTarget.checked = false
        this.selectAllTarget.indeterminate = true
      }
    }

    // Update hidden inputs for form submission
    if (this.hasSelectedIdsTarget) {
      this.selectedIdsTarget.innerHTML = ""
      checkedBoxes.forEach(checkbox => {
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "run_ids[]"
        input.value = checkbox.value
        this.selectedIdsTarget.appendChild(input)
      })
    }
  }
}
